export const CLUB_SORTING_OPTIONS = "CLUB_SORTING_OPTIONS";
export const SEARCH_CLUBS = "SEARCH_CLUBS";
export const CATCHING_TEETIME = "CATCHING_TEETIME";
